import { defineQuery } from 'next-sanity'

export const careersTextColumnsBlockFields = `
  _id,
  _type,
  heading,
  leftContent,
  rightContent
`

export const CAREERS_TEXT_COLUMNS_BLOCK_QUERY = defineQuery(/* groq */ `
  *[_type == "careers-text-columns-block"][0]{
    ${careersTextColumnsBlockFields}
  }
`)
